import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const BESUME_DOMAINS = ['besume.com', 'www.besume.com', 'localhost'];

export function useCustomDomain() {
  const [customDomainData, setCustomDomainData] = useState({
    isCustomDomain: false,
    slug: null,
    loading: true,
  });

  useEffect(() => {
    const hostname = window.location.hostname;
    const isCustomDomain = !BESUME_DOMAINS.some(
      d => hostname === d || hostname.endsWith('.besume.com') || hostname.endsWith('.emergentagent.com')
    );

    if (!isCustomDomain) {
      setCustomDomainData({ isCustomDomain: false, slug: null, loading: false });
      return;
    }

    fetch(`${API}/api/profile/by-domain/${hostname}`)
      .then(res => res.json())
      .then(data => {
        setCustomDomainData({
          isCustomDomain: true,
          slug: data.slug || null,
          loading: false,
        });
      })
      .catch(() => {
        setCustomDomainData({ isCustomDomain: true, slug: null, loading: false });
      });
  }, []);

  return customDomainData;
}
